module.exports = __webpack_public_path__ + "static/media/Step 6-Enter_System_Elevation.7eaea85e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 6-Enter_System_Elevation.gif
// module id = 3046
// module chunks = 0